<template>
<v-form @submit.prevent="save">
    <v-container>
        <v-layout wrap>
            <v-flex xs12 md6 offset-md3>
                <v-autocomplete
                        v-model="travelWarrant.orderer_id"
                        :items="users"
                        :loading="userLoading"
                        name="users"
                        color="indigo"
                        hide-no-data
                        hide-selected
                        clearable
                        item-text="profile.name"
                        item-value="id"
                        :label="$t('Pages.TravelWarrants.model.orderer')"
                        :placeholder="$t('Common.type_to_search')"
                ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md6>
                <v-autocomplete
                        :items="vehicles"
                        v-model="travelWarrant.vehicle"
                        v-validate="'required'"
                        :error-messages="errors.first('vehicle')"
                        :label="$t('Pages.Vehicles.title_singular')"
                        name="vehicle"
                        color="indigo"
                        clearable
                        autocomplete
                        item-text="licence_plates"
                        item-value="id"
                        return-object
                ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md6>
                <v-select
                        :items="TravelWarrantMissions"
                        v-validate="'required'"
                        v-model="travelWarrant.mission"
                        :error-messages="errors.first('mission')"
                        :label="$t('Pages.TravelWarrants.model.mission')"
                        required
                        name="mission"
                        color="indigo"
                        clearable
                ></v-select>
            </v-flex>
            <v-flex xs12 md6>
                <v-datetime-picker
                        :label="$t('Pages.TravelWarrants.model.start')"
                        locale="sr-Latn-RS"
                        format="DD/MM/YYYY HH:mm:ss"
                        name="start"
                        v-model="travelWarrant.start" />
            </v-flex>
            <v-flex xs12 md6>
                <v-datetime-picker
                        :label="$t('Pages.TravelWarrants.model.end')"
                        locale="sr-Latn-RS"
                        format="DD/MM/YYYY HH:mm:ss"
                        name="end"
                        v-model="travelWarrant.end" />
            </v-flex>
                <v-flex xs12 md6>
                    <v-autocomplete
                            v-model="travelWarrant.users"
                            :items="users"
                            :loading="userLoading"
                            name="users"
                            color="indigo"
                            hide-no-data
                            hide-selected
                            clearable
                            multiple
                            item-text="profile.name"
                            item-value="id"
                            :label="$t('Pages.Users.title_singular')"
                            :placeholder="$t('Common.type_to_search')"
                            return-object
                    ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="travelWarrant.destination"
                            :error-messages="errors.first('destination')"
                            :label="$t('Pages.TravelWarrants.model.destination')"
                            type="text"
                            color="indigo"
                            required
                            name="destination"
                    />
                </v-flex>
                <v-flex xs12 md4>
                    <v-switch color="indigo" v-model="travelWarrant.locked" :label="$t('Pages.TravelWarrants.model.locked')"></v-switch>
                </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-btn round color="indigo" dark type="submit">
              {{$t('Core.Fields.save')}}
            </v-btn>
            <v-btn round href="javascript:history.go(-1)">
              {{$t('Core.Fields.back')}}
            </v-btn>
          </v-layout>
    </v-container>
</v-form>
</template>

<script>
    import Form from '../../services/Form'
    import _ from 'lodash';
export default {
  components: {},
  props: {
      travelWarrant: {
          type: Object,
          required: true
      },
      edit: {
          type: Boolean,
          default: false
      }
  },
  data: () => ({
    newUser: {},
    qUser: null,
    users: [],
    userLoading: false,
    vehicles: [],
  }),
  computed: {

  },
  created () {
    this.getVehicles();
    this.getUsers();
  },
  methods: {
        getVehicles(){
            this.repositories.vehicle.all().then((response) => {
              this.vehicles = response.data.data;
            })
        },
        getUsers(q){
          this.userLoading = true;
          this.repositories.user.all(q).then((response) => {
            this.users = response.data.data;
          }).finally(() => {
            this.userLoading = false;
          });
        },
        save(){
            this.$validator.validateAll().then((result) => {
                if (result) {
                  let data = {...this.travelWarrant};
                  data.start = this.getLocalISOFormat(data.start);
                  data.end = this.getLocalISOFormat(data.end);
                  data.vehicle_id = this.travelWarrant.vehicle.id;
                  this.$emit('save', data);
                }
            });
        }
  },
  watch: {

  }
}
</script>

<style lang="scss">

</style>
